import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { passwordReset } from '../../actions/index';

class PasswordReset extends Component {
  constructor(props) {
    super(props);

    this.state = {
      password: {
        value: '',
        error: '',
      },
      passwordAgain: {
        value: '',
        error: '',
      },
    }
  }

  componentDidMount() {
    // Change style of the wrapper so we can put a background image on
    document.getElementById("wrapper").class = "img-cover";
    document.getElementById("wrapper").style = "background-image: url(../assets/img/photos-1/1.jpg); background-repeat: no-repeat; background-size: cover";
  }

  componentWillUnmount() {
    // reset the wrapper class to the original value
    document.getElementById("wrapper").class = "wrapper";
    document.getElementById("wrapper").style = '';
  }

  handlePassword = event => {
    this.setState({ password: { ...this.state.password, value: event.target.value} });
  }

  handlePasswordAgain = event => {
    let error = '';
    if (event.target.value !== this.state.password.value) {
      error = 'Passwords are not the same'
    }

    this.setState({ passwordAgain: { value: event.target.value, error: error }});
  }

  handleSubmit = event => {
    this.props.passwordReset(this.state.password.value, this.state.passwordAgain.value, this.props.match.params.token);
    event.preventDefault();
  }

  renderAlert() {
    if (this.props.errorMessage) {
      return (
        <div className="alert alert-danger">
          <strong>Error: </strong> {this.props.errorMessage}
        </div>
      );
    }
  }

  renderButton() {
    if (this.props.loading) {
      return (
        <div className="center-text pt-1 pb-1">
          <img src="/assets/img/spinner.gif" width="30" height="30" alt="Waiting to confirm password reset." />
        </div>
      )
    } else {
      return (
        <div className="px-2 form-group mb-0 pb-2 pt-1">
          <button action="submit" className="btn btn-rounded btn-secondary btn-block text-uppercase">Reset Password</button>
        </div>
      );
    }
  }

  renderError(field) {
    if (this.state[field].error !== '') {
      return (
        <div className="form-control-feedback">{this.state[field].error}</div>
      );
    }
  }

  renderForm() {
    if (this.props.showForm) {
      return (
        <form className="form-material mb-1" onSubmit={this.handleSubmit}>
          <div className={'form-group ' + (this.state.password.error !== '' ? 'has-danger' : '')}>
            <input name="password" value={this.state.password.value} onChange={this.handlePassword} type="password" className="form-control" placeholder="Password" />
            {this.renderError('password')}
          </div>
          <div className={'form-group ' + (this.state.passwordAgain.error !== '' ? 'has-danger' : '')}>
            <input name="password" value={this.state.passwordAgain.value} onChange={this.handlePasswordAgain} type="password" className="form-control" placeholder="Password Again" />
            {this.renderError('passwordAgain')}
          </div>
          {this.renderAlert()}
          {this.renderButton()}
        </form>
      );
    } else {
      return (
        <div className="center-text pl-1 pr-1 pb-2">
          <span className="h5 text-success">
            Your password has been reset, <a className="text-black" href="/">Sign In</a> to continue.
          </span>
        </div>
      );
    }
  }

  render() {
    return (
      <div className="container-fluid">
        <div className="sign-form">
          <div className="row">
            <div className="col-md-4 offset-md-4 px-3">
              <div className="box b-a-0 mb-0">
                <div className="p-2 text-xs-center">
                  <h5>DineOS Password Reset</h5>
                </div>
                {this.renderForm()}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { errorMessage: state.auth.error, showForm: state.auth.showPasswordReset, loading: state.auth.loading };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ passwordReset }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(PasswordReset);



// WEBPACK FOOTER //
// ./src/containers/auth/password_reset.js